import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./payment-due-notice.component.html?ngResource";
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MessagesModule } from 'primeng/messages';
let PaymentDueNoticeComponent = class PaymentDueNoticeComponent {
    user = null;
    pdnElement;
    messages = [];
    visible = false;
    ngOnInit() {
        const orgSettings = this.user?.org?.settings?.payment || {};
        const dueNotice = Boolean(orgSettings?.dueNotice);
        const dueDateStr = orgSettings?.dueDate;
        this.visible = dueNotice;
        if (this.visible) {
            const diffDays = this.calculateDaysPastDue(dueDateStr);
            const isOverSixty = diffDays > 60;
            const isOverThirty = diffDays > 30;
            const durationText = isOverSixty
                ? '60-days past due and at risk of being suspended.'
                : '30-days past due.';
            const contactHtml = '<a href="mailto:ar@epicio.com">ar@epicio.com</a>';
            const detailText = [
                'This account is over ',
                durationText,
                ' Please remit payment immediately. Contact: ',
                contactHtml
            ].join('');
            this.messages = [
                {
                    severity: isOverThirty ? 'warn' : 'error',
                    summary: 'Warning',
                    detail: detailText
                }
            ];
        }
    }
    ngAfterViewInit() {
        if (this.pdnElement) {
            const pdnHeight = getComputedStyle(this.pdnElement.nativeElement).getPropertyValue('--payment-due-notice-height');
            document.documentElement.style.setProperty('--payment-due-notice-height', pdnHeight);
        }
    }
    calculateDaysPastDue(dueDateStr) {
        if (!dueDateStr) {
            return 0;
        }
        const dueDate = new Date(dueDateStr);
        if (Number.isNaN(dueDate.getTime())) {
            return 0;
        }
        const now = new Date();
        const hoursPerDay = 24;
        const minutesPerHour = 60;
        const secondsPerMinute = 60;
        const millisecondsPerSecond = 1000;
        const msPerDay = hoursPerDay * minutesPerHour * secondsPerMinute * millisecondsPerSecond;
        const diff = now.getTime() - dueDate.getTime();
        return Math.floor(diff / msPerDay);
    }
    static propDecorators = {
        user: [{ type: Input }],
        pdnElement: [{ type: ViewChild, args: ['pdn', { read: ElementRef },] }]
    };
};
PaymentDueNoticeComponent = __decorate([
    Component({
        selector: 'payment-due-notice',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [CommonModule, MessagesModule],
        changeDetection: ChangeDetectionStrategy.OnPush,
    })
], PaymentDueNoticeComponent);
export { PaymentDueNoticeComponent };
